import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { CartProvider } from './hooks/useCart';
import { FavoritesProvider } from './hooks/useFavorites';
import { GoogleMapsProvider } from './components/providers/GoogleMapsProvider';
import { ShopperLocationProvider } from './hooks/useShopperLocation';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GoogleMapsProvider>
      <ShopperLocationProvider>
        <FavoritesProvider>
          <CartProvider>
            <RouterProvider router={router} />
          </CartProvider>
        </FavoritesProvider>
      </ShopperLocationProvider>
    </GoogleMapsProvider>
  </React.StrictMode>,
);
